module.exports = __webpack_public_path__ + "img/txt.11bdb5ca.svg";